import { render } from "./XRecyclerList.vue?vue&type=template&id=b8a5a174&scoped=true"
import script from "./XRecyclerList.vue?vue&type=script&lang=js"
export * from "./XRecyclerList.vue?vue&type=script&lang=js"

import "./XRecyclerList.vue?vue&type=style&index=0&id=b8a5a174&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a5a174"]])

export default __exports__